import { useContext, useState } from "react";
import { useSelector } from "react-redux";

import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { useAppDispatch, useAppSelector } from "store";
import { createFlowResponse, fetchDynamicForm } from "store/actions/flow";
import { setJourneyProgressPercentOverride } from "store/actions/journey";
import { setModal } from "store/actions/modal";
import { getJourneyProgress } from "store/selectors";
import { buildFormInputs } from "utils/form";

export const useEditResponse = () => {
  const { dynamicForm } = useContext(DynamicFormContext);
  const flowSessionId = useAppSelector(state => state.formFlow.flowSessionId);
  const [isRequestingEdit, setIsRequestingEdit] = useState(false);
  const { percentage: journeyProgressPercentage } = useSelector(getJourneyProgress);

  const dispatch = useAppDispatch();

  const editResponseCommand = async (itemId: string) => {
    setIsRequestingEdit(true);

    try {
      if (journeyProgressPercentage) {
        dispatch(setJourneyProgressPercentOverride(journeyProgressPercentage));
      }

      await dispatch(
        createFlowResponse({
          flowSessionId,
          formInputs: buildFormInputs([
            {
              id: "review",
              metadata: { flowInputType: "inputSingleSelect" },
              value: itemId,
            },
          ]),
        })
      ).unwrap();

      await dispatch(
        fetchDynamicForm({
          currentFormIdentifier: dynamicForm.id,
          flowSessionId,
          direction: "next",
        })
      );
    } catch (error) {
      dispatch(setModal("GeneralErrorModal", { error }));
    } finally {
      setIsRequestingEdit(false);
    }
  };

  return { isRequestingEdit, editResponse: editResponseCommand };
};
